import React from 'react';
import { Box, Typography, Button } from '@mui/material';

interface PropertyFooterLayoutProps {
  progress: number;
  step: number;     
  onBack?: () => void;    
  onContinue?: () => void; 
  isContinueDisabled?: boolean; 
}

const PropertyFooterLayout: React.FC<PropertyFooterLayoutProps> = ({
  progress,
  step,
  onBack,
  onContinue,
  isContinueDisabled = true,
}) => {

  const barWidth = 100 / 3; 

  const getSectionProgress = (section: number) => {
    if (section === step) {
      return progress;
    } else if (section < step) {
      return 100; 
    }
    return 0; 
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        backgroundColor: 'white',
        boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
        zIndex: 1000,
        padding: 2,
        boxSizing: 'border-box',
      }}
    >
      {/* Barra de progreso */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          height: '10px',
          width: '100%',
        }}
      >
        {[1, 2, 3].map((section) => (
          <Box
            key={section}
            sx={{
              width: `${barWidth}%`,
              height: '100%',
              backgroundColor: '#ddd',
              borderRadius: '4px',
              position: 'relative',
              marginRight: section < 3 ? '4px' : '0', 
            }}
          >
            <Box
              sx={{
                width: `${getSectionProgress(section)}%`,
                height: '100%',
                backgroundColor: '#4caf50',
                borderRadius: '4px',
                position: 'absolute',
                top: 0,
                left: 0,
              }}
            />
          </Box>
        ))}
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          mt: 2,
        }}
      >
        <Button
          variant="text"
          color="primary"
          onClick={onBack}
          sx={{ flexShrink: 0, fontWeight: '600' }}
        >
          Atrás
        </Button>
        <Typography variant="body2" sx={{ flexShrink: 0 }}>
          Paso {step} de 3
        </Typography>
        <Button
          variant="contained"
          color="success"
          onClick={onContinue}
          disabled={isContinueDisabled}
          sx={{ flexShrink: 0 }}
        >
          Siguiente
        </Button>
      </Box>
      <Box
    sx={{
      height: "80px",
      display: { xs: "block", sm: "none" },
      width: "100%",
    }}
  />
    </Box>
  );
};

export default PropertyFooterLayout;
